import axiosInstance from "./axiosInstance";

export async function createAspekAdministrasi(data) {
  return await axiosInstance.post("/aspek-administrasi", data);
}

export async function updateAspekAdministrasi(data) {
  return await axiosInstance.put("/aspek-administrasi", data);
}

export async function findAspekAdministrasiByYearAndMonthAndPerusahaanId({ year, month, perusahaanId }) {
  return await axiosInstance.get(`/aspek-administrasi/filter?year=${year}&month=${month}&perusahaan=${perusahaanId}`);
}
